import { useRefuseLeadsTypeSelectOptions } from "components/UI/Selects/RefuseLeadsTypeSelectSearchable/useRefuseLeadsTypeSelectOptions.ts";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

export const RefuseLeadsTypeSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useRefuseLeadsTypeSelectOptions();

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.type"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
